/**
 * TanStack Query hooks for `google-ads-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	googleAdsIntegrationQueryKeys,
	type CreateGoogleAdsIntegrationBody,
	type ListGoogleAdsIntegrationResponse,
	type GoogleAdsIntegrationRow,
} from "./api";

export function useGoogleAdsIntegrationList(): UseQueryResult<ListGoogleAdsIntegrationResponse, Error> {
	return useQuery({
		queryKey: googleAdsIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useGoogleAdsIntegrationCreate(): UseMutationResult<GoogleAdsIntegrationRow, Error, CreateGoogleAdsIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsIntegrationQueryKeys.all });
		},
	});
}

export function useGoogleAdsIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsIntegrationQueryKeys.all });
		},
	});
}
